<template lang="pug">
	div
		.sfc-container-redesign-v1
			sfc-sentry
			sfc-hello-bar-v3
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-menu
			sfc-menu-mobile
			sfc-onboarding-modal-v2
			sfc-header
			sfc-login
			sfc-forgot-password
			main#sfc-main-content-new
				nuxt
			no-ssr(v-if="!userSubscribed()")
				#bottom-ad
					.bottom-banner
						sfc-dfp-ad(ad-unit="savingforcollege_other_bottom_leaderboard" sizes="[[600,230], [728,90]]")
			sfc-footer
			no-ssr
				sfc-gdpr-banner
			no-ssr
				sfc-modal-trigger
			no-ssr
				enroll-now-modal
		no-ssr
			sfc-college-savings-questions-modal
</template>

<style lang="stylus">
@import '~assets/css/redesign-v1/common.styl'
</style>

<style lang="stylus" scoped>
	#bottom-ad
		background: #f8f8f8
		.bottom-banner
			text-align: center
			padding: 24px 0
			@media (max-width: 767px)
				padding: 16px 0
</style>

<script>
import SfcHeader from '@/layouts/common/redesign-v1/sfc-header'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import SfcModalTrigger from '@/common/components/modals/modal-trigger'
import EnrollNowModal from '@/common/components/modals/enroll-now-modal'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcHelloBarV3 from '@/common/components/hello-bar/sfc-hello-bar-v3'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcEnrollNowUrgencyWidget from '@/common/components/redesign-v1/sfc-enroll-now-urgency-widget'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'

export default {
	components: {
		SfcHeader,
		SfcFooter,
		SfcModalTrigger,
		sfcCollegeSavingsQuestionsModal,
		EnrollNowModal,
		SfcHelloBarV3,
		SfcMenu,
		SfcEnrollNowUrgencyWidget,
		SfcMenuMobile,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2
	},
	methods: {
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		}
	}
}
</script>
